import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription, filter} from 'rxjs';
import {ConfirmModalComponent} from 'src/app/core/components/dialog/components/confirm-modal/confirm-modal.component';
import {DialogService} from 'src/app/core/components/dialog/dialog.service';
import {FormConfiguration} from 'src/app/core/components/dynamic-form/models/form-config';
import {QuestionBase} from 'src/app/core/components/dynamic-form/models/question-base';
import {ViewManagerService} from 'src/app/core/services/view-manager-service';
import {Company} from 'src/app/lem/models/companies/company';
import {Person} from 'src/app/lem/models/person/person';
import {PersonService} from '../../../person/services/person.service';
import {CompanyService} from '../../service/company.service';
import {InserimentoSocietaComponent} from '../components/inserimento-societa/inserimento-societa-form.component';
import {searchConfig} from './form-config/search-config';
import {CompanyType} from 'src/app/lem/models/companies/company-type';
import {CompanyScope} from '../../../../models/companies/company-scope';
import {CompanyStatus} from '../../../../models/companies/company-status';
import { PaginatedResponse } from 'src/app/lem/models/common/paginated-response';
import { Pagable } from 'src/app/lem/models/common/pagable';
import { DialogRef } from 'src/app/core/components/dialog/dialog-ref';
import { Pagination } from 'src/app/common/models/pagination';

@Component({
  selector: 'main [gestionesocieta]',
  templateUrl: './gestionesocieta.component.html',
  styleUrls: ['./gestionesocieta.component.css'],
  host: {'[attr.id]': '\'content\''}
})
export class GestionesocietaComponent implements OnInit, OnDestroy {


  formFields: QuestionBase[] = []
  formConfiguration: FormConfiguration = {
    buttons: [
      {
        bg: '',
        width: '',
        type: 'submit',
        title: 'Ricerca',
        class: 'btn-primary',
      },
      {
        bg: '',
        width: '',
        type: 'reset',
        title: 'Reset',
        class: 'btn-secondary',
      }
    ]
  }

  companyStatuses: CompanyStatus[];
  companyScopes: CompanyScope[];
  companyTypes: CompanyType[];
  companyPersons: Person[];
  companyList: PaginatedResponse<Company>;
  subscriptionRefresh: Subscription;

  searchParamsCache: any;
  pagable: Pagable = new Pagable();
  resetCurrentPage: boolean = false;

  constructor(
    private modal: DialogService,
    private companyService: CompanyService,
    private personService: PersonService,
    private viewManager: ViewManagerService
  ) {

  }


  ngOnInit() {
    this.viewManager.svuotaMenu();

    this.formFields = searchConfig;
    // GET DATA NEEDED FOR THE FORM
    this.companyService.getAllCompanyStatuses().subscribe((data) => {
      this.companyStatuses = data
    });
    this.companyService.getAllCompanyScopes().subscribe((data) => {
      this.companyScopes = data;
    });
    this.companyService.getAllCompanyTypes().subscribe((data) => {
      this.companyTypes = data
    });
    this.personService.getAllPerson().subscribe((data) => {
      this.companyPersons = data.items
    });

    this.subscriptionRefresh = this.companyService.RefreshRequired$
      .subscribe(() => {
        this.onRefresh();
      });
    this.onRefresh();
  }

  //TSR 185- TO FIX IMPORTANT REFRESHSUB GET PREVIUSVALUE
  ngOnDestroy(): void {
    if(this.subscriptionRefresh) this.subscriptionRefresh.unsubscribe();
  }

  onLoadData() {
    this.formFields = this.formMapper(searchConfig);
  }

  formMapper(config: QuestionBase[]) {
    const indexType = config.findIndex(el => el.key === 'type');
    const indexScope = config.findIndex(el => el.key === 'scope');
    //const indexOwner = config.findIndex(el => el.key === "owner");
    config = this.elementMapper(config, this.companyScopes, indexScope);
    return this.elementMapper(config, this.companyTypes, indexType);
    //return  this.elementMapper(config,this.Person,indexOwner);
  }

  private elementMapper(fields: QuestionBase[], data: any, indexTipo: number) {
    fields[indexTipo].options = data.map(el => {
      return {
        key: el.id,
        value: el,
        label: el.name
      };
    });
    return fields;
  }


  addCompanies() {
    const ref = this.modal.open(InserimentoSocietaComponent, {
      data: {
        statuses: this.companyStatuses,
        style: {
          width: '50%'
        },
        scopes: this.companyScopes,
        types: this.companyTypes,
        person: this.companyPersons,
        formSettings: {
          formEdit: false,
          formData: ''
        }
      }
    })
    this.modalCloseEvent(ref);
  }

  onEditCompany(company: Company) {
    const ref = this.modal.open(InserimentoSocietaComponent, {
      data: {
        style: {
          width: '65%'
        },
        statuses: this.companyStatuses,
        scopes: this.companyScopes,
        types: this.companyTypes,
        person: this.companyPersons,
        formSettings: {
          formEdit: true,
          formData: company
        }
      }
    })
    this.modalCloseEvent(ref);
  }

  onDeleteCompany(company: Company) {
    const ref = this.modal.open(ConfirmModalComponent, {
      data: {
        modalConfirm: {

          text: 'Eliminare la societa  ' + company.name + '?',
          data: company,
        },
        style: {width: '30%'},
        title: 'Eliminazione Societa',
      }
    })
    this.modalCloseEvent(ref);
  }

  // MODAL EVENT MANAGER   EDITMODE - CONFIRM  - ADD MODE
  modalCloseEvent(ref: DialogRef) {
    ref.afterClosed.pipe(
      filter(response => response)
    ).subscribe((data) => {
      if(data.closeEvent) return;
      if (data.edit) {
        this.companyService.editCompany(data.data).subscribe();
      } else if (data.modalEvent) {
        this.companyService.deleteCompany(data.data).subscribe();
      } else {
        this.companyService.addCompany(data.data).subscribe();
      }
    })
  }

  getAllCompany() {
    this.companyService.getAllCompany().subscribe({
      next: (data) => {
        this.companyList = data;
      },
      error: () => {
      }
    });
  }

  onSearch(searchParams){
    this.pagable.page = 0;
    this.resetCurrentPage = true;
    this.sendSearch(searchParams);
  }

  sendSearch(searchParams) {
    this.companyService.searchCompany(this.cleanEmpty(searchParams),this.pagable).subscribe((res) => {
      this.searchParamsCache = searchParams;
      this.companyList = res;
    });
  }

  cleanEmpty(obj) {
    for (let propName in obj) {
      if (!obj[propName]) {
        delete obj[propName];
      }
    }
    return obj
  }

  onRefresh(pagination?: Pagination) {
    if (pagination) {
      this.pagable.size = pagination.getItemsPerPage();
      this.pagable.page = pagination.getCurrentPage();
    }
    this.sendSearch(this.searchParamsCache);
    this.resetCurrentPage = false;
  }

}
